import React from "react";
import "./index.css";
import {useJCommonContext} from "../JCommonProvider";

type WalletInfoProps = {
    type?: "badge" | "list";
    wallets: any[];
}

export const WalletInfo: React.FC<WalletInfoProps> = ({ type, wallets }) => {
    const isEventExtra = wallets?.find(wallet => wallet?.referredEventId);
    const {getImageURL} = useJCommonContext();
    return (<>
            {!!isEventExtra ? null : <>
                {wallets?.length ?
                    <div className={type === 'badge' ? "wallet-badge" : "wallet-list"}>
                        {wallets?.map((wallet: any, index: number) => {
                            if (type === 'badge') {
                                return (
                                    <div key={index} className="wallet-badge-item">
                                        <img aria-hidden={true} src={getImageURL(wallet.walletCms?.imageRef)} />
                                        <b>{wallet.amount}</b>
                                    </div>
                                );
                            } else if (type === 'list') {
                                return (
                                    <div className="wallet-list-item">
                                        <div>{wallet.walletCms?.title}</div>
                                        <div className="wallet-list-item-counter">
                                            <b style={{color: 'var(--darkGray)'}}>+{wallet.amount}</b>
                                            <img aria-hidden={true} src={getImageURL(wallet.walletCms?.imageRef)} />
                                        </div>
                                    </div>
                                )
                            } else {
                                return null
                            }
                        })}
                    </div>
                    : null}
            </>}
        </>
    );
};
